import React from "react";

import './destination.css'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel'; 
import Typography from '@mui/material/Typography';
import SimpleImageSlider from "react-simple-image-slider";
import Swipernew from "./Swipernew";
import slide_image_1 from '../pages/image1/IMG-20240928-WA0016.jpg';
import slide_image_2 from '../pages/image1/IMG-20240928-WA0015.jpg';
import slide_image_3 from '../pages/image1/IMG-20240928-WA0013.jpg';
import slide_image_4 from '../pages/image1/IMG-20240928-WA0017.jpg';

export default function Destination5() {
 
 const imageArray = [
  slide_image_1,
  slide_image_2,
  slide_image_3,
  slide_image_4,

];
  return (
    <>
  <div>
  <div>
            <Swipernew images={imageArray} />
        </div>
<div className=" m-2 pt-5 ">
        <div className="container-fluid">
        <div className="ms-auto me-auto  bg2">

<h1 className="text-center name11  ">
3-Days Gorilla Trekking Tour in Uganda
</h1>
</div>
       

          <h2>Description:</h2>
          <h3 className="ms-5 pt-3">
            &emsp;  &emsp;This once in a life time experience will start and end in Kampala the Capital city of Uganda or Entebbe being close to the airport. The Gorilla tracking will take place in Bwindi Impenetrable National Park located in South Western part of Uganda. Gorilla tracking is the main highlight of our tourism. It is also one of the most unforgettable wildlife encounters in the world. On this day, enjoy the Batwa Community trail and as well as canoeing on Lake Bunyonyi.
          </h3>
        </div>
        <h2>Tour Highlights:</h2>
          
           <ul type="circle" className="fs-3 m-3">
            <li>* Gorilla Tracking-Bwindi Impenetrable National Park</li>
            <li>* Lake Bunyonyi</li>
            <li>* Equator</li>
           </ul>
       
        <div>

        </div>

        <div className="container-fluid">
        <Box sx={{ padding: 2 }}>
      <Stepper orientation="vertical" activeStep={5}>
        {steps.map((step, index) => (
          <Step key={step.label1} color="black">
            {/* Pass label1 to StepLabel */}

            <StepLabel><h3> {step.label1}</h3></StepLabel>
            <div className=" bordernew  ">
            {/* Add the secondary label (optional, shown below the main one) */}
            <Typography variant="subtitle1" color="textblack" sx={{ ml: 2 }}>
              <h4><b>{step.label}</b></h4>
            </Typography>
            {/* Directly display the description */}
            <Typography sx={{ mt: 1, mb: 2, ml: 2 }}><h4>&emsp;{step.description}</h4></Typography></div>
          </Step>
        ))}
      </Stepper>
    </Box>
         

         

          

        
        </div>
          
      
      </div>
      <div class="btn-box text-white text-center">
                        <a href="https://wa.me/+971551579904" class="theme-btn btn-style-one rounded-3 m-4 ">Book Now</a>
                    </div></div>

      
    </>
  );
}
const steps = [
  {
    label1: 'Day - 1',
    label: 'Transfer to Bwindi Impenetrable National Game Park',
 
    description: `Upon check in to your hotel, you will be met by a member of JAPLAND TOURS AND SAFARIS to take you through the details of the Itinerary for the following day. The drive to Bwindi National Park is approximately 7 hours with a lunch stopover on your way. This is also a great opportunity for you to appreciate the beautiful landscape of Uganda as you will be driven through different features including tropical rain forests, savannah fields, and the terraced hills of Kigezi which was popularly known as the Switzerland of Africa. Upon arrival in Bwindi, we shall check in at the lodge and proceed to the Batwa community for the cultural adventure about the pygmies along this area. You will spend the rest of the evening at leisure and enjoy your dinner as you wait for the next day’s adventure.
`,
  },
  { 
    label1: 'Day - 2',
    label: 'Gorilla Trekking Day-Bwindi Impenetrable National Game Park',

    description:
      (<>  <p>Having enjoyed freshly early morning breakfast, you will proceed for a briefing where you will meet your professional and yet experienced local guides and trackers who will give you a briefing about gorilla trekking dos and don’ts. We shall then hike into the dense forest to a spot where gorillas could be as it will be advised by the guides. </p> <p>Mountain Gorillas are extremely rare with only an estimate of around 880 remaining in the whole world.</p>  <p>You will have the opportunity to see these magnificent animals just few meters away as they go along with their daily life. Trekking may take anything between 1 to 6 hours depending on the location of the family and altitudes which is in excess of 7500 feet. Although the hike is physically demanding, the beauty of the forest and surrounding scenery makes the trekking worthwhile. All meals are covered. Later, transfer to Lake Bunyonyi.
        </p> </>)
       ,
  },
  {
    label1: 'Day - 3',
    label: '   Transfer to Kampala /Entebbe via Equator Line',
    description: `After breakfast, start on the long drive back to Entebbe / Kampala with an everlasting memory of this Gorilla trekking experience. Have lunch en route and a stopover at the equator line for experimentation and photo shoot. You will arrive late in the evening at your final destination approximately at 18:00. We recommend to book late evening flight! Or a flight the next day.`
  },
  
];
